import React from 'react';
import { Link } from 'react-router-dom';
import { IMGBASEAPIURL } from '../../config';

function CalendarBox({ className }) {
    return (
        <>
            <section className={`d-none calendar-area ${className || ''}`}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="calendarBox">
                                <div className="calendarText">
                                    <h3>Click on your preferred date from the Course Calendar</h3>
                                    <Link to="/calendar" className="main-btn">
                                        View Course Calendar
                                    </Link>
                                </div>
                                <div className="calendarImg">
                                    <img
                                        src={`${IMGBASEAPIURL}institute/calendar/calendar-img1.png`}
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default CalendarBox;
